import {
	AUTH_FAILURE,
	AUTH_INIT,
	AUTH_SUCCESS,
	AuthActionTypes,
	AuthState,
	RESET_AUTH
} from "./types";

const initialState: AuthState = {
	uid: null,
	isAuthenticating: false,
	authenticatingService: null,
	authenticated: false,
	errorAuthenticating: null
};

export default function appReducer(state = initialState, action: AuthActionTypes) {
	switch (action.type) {
		case AUTH_INIT:
			return {
				...state,
				isAuthenticating: true
			};

		case AUTH_SUCCESS:
			return {
				...state,
				isAuthenticating: false,
				authenticated: true,
				uid: action.uid
			};

		case AUTH_FAILURE:
			return {
				...state,
				isAuthenticating: false,
				authenticated: false,
				errorAuthenticating: action.error
			};

		case RESET_AUTH:
			return initialState;

		default:
			return state;
	}
}
